module.exports = __webpack_public_path__ + "img/qa.914d1715.svg";